export type NonPharmaItemFormValue = {
  skuId: string;
  skuName: string;
  skuBrand: string;
  nonPharmaItemId: string;
  // Stored as the raw form value — `RHFTextField type="number"` hands
  // back a string in Ward Supplies (no Yup coercion); the dispense hook
  // normalizes it at the edge via `toQuantity`.
  quantity: number | string;
  lotId: string | null;
};

export const emptyNonPharmaItem = (): NonPharmaItemFormValue => ({
  skuId: "",
  skuName: "",
  skuBrand: "",
  nonPharmaItemId: "",
  quantity: 1,
  lotId: null,
});
